import React from 'react';
import { Icon } from '../Icon';
import type { IconProps } from '../.types/IconPropsType';

export function CalendarPlusIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M12 10H14V16H12V10Z" />
        <path d="M10 12H16V14H10V12Z" />
        <path d="M13 2H15C15.552 2 16 2.448 16 3V9H14V7H2V14H9V16H1C0.448 16 0 15.552 0 15V3C0 2.448 0.448 2 1 2H3V0H6V2H10V0H13V2Z" />
      </svg>
    </Icon>
  );
}
